import React from 'react'

import lang from '@/lang'
import styles from './back-button.css'
import PropTypes from 'prop-types'
import SVGIcon from '@/modules/base/components/svg-icon/svg-icon'
import ArrowIcon from '@assets/images/icons/arrow_left.svg'

const BackButton = (props) => {
  const { label, customClass, onClick, disabled = false, dataQsId } = props

  return (
    <button data-qs-id={dataQsId} className={`${styles.button} ${customClass || ''}`} type='button' onClick={onClick} disabled={disabled}>
      {label || <><SVGIcon svg={ArrowIcon} height='10px' width='auto' />{lang.backButtonLabel}</>}
    </button>
  )
}
BackButton.propTypes = {
  label: PropTypes.string,
  customClass: PropTypes.string,
  onClick: PropTypes.func.isRequired,
  disabled: PropTypes.bool,
  dataQsId: PropTypes.string.isRequired,
}
export default BackButton
